import { createRoot } from "react-dom/client"
import { App } from "./App"
import { AppProviders } from "./app/AppProviders"
import { createBrowserPlatform } from "./platform/browser"

import "../styles/globals.css"

const elem = document.getElementById("root")
if (!elem) {
	throw new Error("Failed to locate the root element")
}
const app = (
	<AppProviders platform={createBrowserPlatform()}>
		<App />
	</AppProviders>
)

if (import.meta.hot) {
	// With hot module reloading, `import.meta.hot.data` is persisted.
	let root = import.meta.hot.data.root
	if (!root) {
		root = createRoot(elem)
	}
	root.render(app)
} else {
	// The hot module reloading API is not available in production.
	createRoot(elem).render(app)
}
